import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { DateRangeFilter as DateRangeFilterEnum } from '@src/types';
import { compact } from 'lodash';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const DateRangeFilter = ({ value, includePast7Days, onChange }) => {
    const { t } = useLocale();
    const options = useMemo(() => {
        return compact([
            { value: '', label: t('No range') },
            includePast7Days && {
                value: DateRangeFilterEnum.PAST_7_DAYS,
                label: t('Past 7 days'),
            },
            { value: DateRangeFilterEnum.PAST_90_DAYS, label: t('Past 90 days') },
            { value: DateRangeFilterEnum.PAST_YEAR, label: t('Past year') },
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [includePast7Days]);
    return (_jsx(Select, { label: t('Date range'), placeholder: t('No range'), value: value || '', onChange: e => onChange(!e.target.value ? undefined : e.target.value), options: options, isClearable: false }));
};
